import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import {
  APPOINTMENT_TABLE_HEADERS,
  MY_APPOINTMENT_TABLE_HEADERS,
  getLocationColumnLabel,
} from "./appointmentViewShared";

export type SortDirection = "asc" | "desc";

export default function AppointmentTableHead({
  sticky = false,
  showDoctorColumn = true,
  tokenOnly = false,
  myAppointmentLayout = false,
  sortableKeys,
  sortKey = null,
  sortDirection = "asc",
  onSortChange,
}: {
  sticky?: boolean;
  showDoctorColumn?: boolean;
  tokenOnly?: boolean;
  myAppointmentLayout?: boolean;
  sortableKeys?: string[];
  sortKey?: string | null;
  sortDirection?: SortDirection;
  onSortChange?: (key: string) => void;
}) {
  const locationLabel = getLocationColumnLabel(tokenOnly);
  const headers = myAppointmentLayout
    ? MY_APPOINTMENT_TABLE_HEADERS
    : showDoctorColumn
      ? APPOINTMENT_TABLE_HEADERS
      : APPOINTMENT_TABLE_HEADERS.filter((col) => col.key !== "doctor");

  return (
    <thead
      className={`bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-700 dark:to-slate-800 border-b-2 border-slate-200 dark:border-slate-600 ${
        sticky ? "sticky top-0 z-10 shadow-sm" : ""
      }`}
    >
      <tr>
        {headers.map((col) => {
          const isSortable = sortableKeys?.includes(col.key) && onSortChange;
          const isActive = sortKey === col.key;
          return (
            <th
              key={col.key}
              className={`px-2.5 xl:px-3 py-2.5 text-[11px] font-bold text-slate-600 dark:text-slate-200 uppercase tracking-wider ${
                col.align === "center"
                  ? "text-center w-16 xl:w-20"
                  : "text-left"
              }`}
            >
              {isSortable ? (
                <button
                  type="button"
                  onClick={() => onSortChange?.(col.key)}
                  className={`inline-flex items-center gap-1 hover:text-slate-900 dark:hover:text-white transition-colors ${
                    isActive ? "text-slate-900 dark:text-white" : ""
                  }`}
                  title={`Sort by ${col.key === "location" ? locationLabel : col.label}`}
                >
                  <span>{col.key === "location" ? locationLabel : col.label}</span>
                  {isActive ? (
                    sortDirection === "asc" ? (
                      <ArrowUpwardIcon sx={{ fontSize: 13 }} />
                    ) : (
                      <ArrowDownwardIcon sx={{ fontSize: 13 }} />
                    )
                  ) : (
                    <UnfoldMoreIcon sx={{ fontSize: 13 }} className="opacity-50" />
                  )}
                </button>
              ) : col.key === "location" ? (
                locationLabel
              ) : (
                col.label
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}
